module.exports = __webpack_public_path__ + "static/media/via-soft.8916721b.png";